<template>
  <v-app :dark="dark">
    <AppAdminNavDrawer
      :me="getMe"
      :drawer="adminDrawer"
      :is-admin="isAdmin"
      :can-view-admin="canViewAdmin"
      :limited-user="limitedUser"
      @routeTo="routeTo"
      @changeAdmin="changeAdmin"
    />

    <AppPartnerNavDrawer
      :me="getMe"
      :drawer="partnerDrawer"
      :is-partner="isPartner"
      :can-view-partner-admin="canViewPartnerAdmin"
      :current-partner-i-d="currentPartnerID"
      @routeTo="routeTo"
      @changePartner="changePartner"
    />

    <AppMobileNavDrawer
      :me="getMe"
      :drawer="drawer"
      :is-admin="isAdmin"
      :can-view-admin="canViewAdmin"
      :is-partner="isPartner"
      :can-view-partner-admin="canViewPartnerAdmin"
      :has-reseller="hasReseller"
      :limited-user="limitedUser"
      :is-authenticated="isAuthenticated"
      :clubhouse="clubhouse ? clubhouse : {}"
      :dashboard-link="dashboardLink"
      @routeTo="routeTo"
      @changeAdmin="changeAdmin"
      @changePartner="changePartner"
      @logout="logout"
      @setDrawerValue="setDrawerValue"
    />
    <!-- @closeMobileDrawer="closeMobileDrawer" -->

    <!-- //* Alternate language switcher -->
    <!-- <v-list-tile style="cursor: pointer">
          <v-list-tile-action class="menu-item">
            <v-icon>language</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-dialog v-model="mobileLocaleDialog" width="300">
              <template v-slot:activator="{ on }">
                <v-list-tile-title v-on="on">{{ $t('nav.lang') }}</v-list-tile-title>
              </template>

              <v-card>
                <v-card-text>Please choose your language:</v-card-text>
                <v-flex xs12>
                  <LocaleSwitcher />
                </v-flex>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="mobileLocaleDialog = false"> close </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-list-tile-content>
        </v-list-tile> -->
    <!-- </v-list>
    </v-navigation-drawer> -->

    <!-- Main Navigation Bar -->
    <v-toolbar
      v-if="toolbarRouteCheck || isAuthenticated"
      class="toolbar"
      dark
      flat
      :style="!isAuthenticated && routeAuthCheck ? 'z-index: 2' : ''"
    >
      <div v-if="isAuthenticated" class="toolbar-menu tablet" data-cy="mainNav">
        <v-app-bar-nav-icon
          class="nav-menu-icon"
          @click.stop="drawer = !drawer"
        ></v-app-bar-nav-icon>
        <img
          v-if="getMe && getMe.id"
          class="top-nav-icon"
          height="50"
          width="50"
          alt="E6 Logo"
          :src="E6Logo"
          data-cy="e6Logo"
          @click="routeTo(`${getMe ? `/users/${getMe.id}` : '/dashboard'}`)"
        />
        <v-tabs v-model="selected" dark class="tabs-bar hidden-tablet">
          <v-tabs-slider class="slider" color="primary" secondary></v-tabs-slider>
          <v-tab
            v-for="(item, i) in filteredTopMenu"
            :key="i"
            :class="['tab-item', `item-${i}`]"
            :to="item.to"
            ripple
          >
            <span>{{ item.title }}</span>
          </v-tab>
        </v-tabs>
        <v-spacer class="hidden-tablet"></v-spacer>

        <!-- //* Alternate language switcher -->
        <!-- <div class="locale-badge-container hidden-tablet">
          <v-badge
            right
            overlap
            :value="itemTotal"
            transition="slide-y-transition"
            class="locale-badge"
          >
            <v-dialog v-model="localeDialog" width="400">
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" medium color="grey lighten-1"> language </v-icon>
              </template>

              <v-card>
                <v-card-text>Please choose your language:</v-card-text>
                <v-flex xs12>
                  <LocaleSwitcher />
                </v-flex>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="localeDialog = false"> close </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-badge>
        </div> -->

        <div class="cart-badge-container">
          <v-badge
            right
            overlap
            :value="itemTotal"
            transition="slide-y-transition"
            class="cart-badge"
            :class="{ 'cart-badge-lg': itemTotalLength >= 2 }"
          >
            <template #badge>
              <div>
                <span>{{ itemTotal }}</span>
              </div>
            </template>
            <v-icon medium color="grey lighten-1" data-cy="shoppingCartIcon" @click="goToCart">
              shopping_cart
            </v-icon>
          </v-badge>
        </div>

        <v-menu
          bottom
          left
          :nudge-width="150"
          :nudge-bottom="48"
          class="outer-nav-items hidden-tablet"
        >
          <template #activator="{ on }">
            <v-btn class="hidden-tablet mt-2" icon v-on="on">
              <v-avatar
                v-if="getMe && getMe.profileImage && profileImage"
                class="hidden-tablet toolbar-avatar"
                size="38px"
                data-cy="avatarBtn"
              >
                <v-img
                  v-if="profileImage && profileImage.imageURL"
                  :src="`${profileImage.imageURL}?w=200&h=200&fit=crop`"
                  alt="User Profile Image"
                  :lazy-src="lazyProfileImage"
                />
              </v-avatar>
              <span v-else class="hidden-logout" data-cy="logout" @click="logout()">{{
                $t('nav.logout')
              }}</span>
            </v-btn>
          </template>

          <v-list dense class="dropdown" data-cy="menuNav">
            <router-link v-if="!limitedUser && getMe && getMe.id" :to="`/users/${getMe.id}`">
              <v-list-item class="active-user-container">
                <div v-if="displayName" class="active-user-details" data-cy="menuDisplayName">
                  <span :class="$vuetify.theme.dark ? 'dark-link-color' : 'light-link-color'">
                    {{ displayName }}
                  </span>
                </div>
              </v-list-item>
            </router-link>

            <v-divider v-if="isAdmin || canViewAdmin"></v-divider>

            <v-list-item
              v-if="isAdmin || canViewAdmin"
              :class="$vuetify.theme.dark ? 'dark-link-color' : 'light-link-color'"
              @click.stop="changeAdmin"
            >
              <v-icon :color="$vuetify.theme.dark ? 'white' : 'primary'" class="pr-1">lock</v-icon>
              Admin
            </v-list-item>

            <v-list-item
              v-if="isPartner || canViewPartnerAdmin"
              :class="$vuetify.theme.dark ? 'dark-link-color' : 'light-link-color'"
              @click.stop="changePartner"
            >
              <v-icon :color="$vuetify.theme.dark ? 'white' : 'primary'" class="pr-1">
                handshake
              </v-icon>
              Partner
            </v-list-item>

            <v-divider v-if="!limitedUser"></v-divider>

            <router-link
              v-if="getMe && getMe.id"
              :to="{
                path: `/users/${getMe.id}`,
                props: true,
                name: 'userProfile',
                params: {
                  id: `${getMe.id}`,
                },
              }"
            >
              <v-list-item :class="$vuetify.theme.dark ? 'dark-link-color' : 'light-link-color'">
                <v-icon :color="$vuetify.theme.dark ? 'white' : 'secondary'" class="pr-1">
                  account_circle
                </v-icon>
                {{ $t('nav.profile') }}
              </v-list-item>
            </router-link>

            <router-link
              v-if="clubhouse"
              :to="{
                path: `/clubhouse${dashboardLink}`,
                props: true,
                name: dashboardLink === 's' ? 'clubhouses' : 'clubhouseDashboard',
                params: {
                  clubhouseID: dashboardLink,
                  clubhouse: clubhouse,
                },
              }"
            >
              <v-list-item :class="$vuetify.theme.dark ? 'dark-link-color' : 'light-link-color'">
                <v-icon :color="$vuetify.theme.dark ? 'white' : 'secondary'" class="pr-1">
                  dashboard
                </v-icon>
                {{ $t('nav.myClubhouse') }}
              </v-list-item>
            </router-link>

            <v-divider></v-divider>

            <router-link v-if="!limitedUser" :to="`/settings/profile`">
              <v-list-item :class="$vuetify.theme.dark ? 'dark-link-color' : 'light-link-color'">
                {{ $t('settingsNav.editProfile') }}
              </v-list-item>
            </router-link>
            <router-link v-if="!limitedUser" :to="`/users/${getMe.id}/bag-management`">
              <v-list-item :class="$vuetify.theme.dark ? 'dark-link-color' : 'light-link-color'">
                {{ $t('settingsNav.bagManagement') }}
              </v-list-item>
            </router-link>
            <router-link v-if="!limitedUser" :to="`/settings/account`">
              <v-list-item :class="$vuetify.theme.dark ? 'dark-link-color' : 'light-link-color'">
                {{ $t('settingsNav.account') }}
              </v-list-item>
            </router-link>
            <router-link v-if="!limitedUser" :to="`/settings/licenses`">
              <v-list-item :class="$vuetify.theme.dark ? 'dark-link-color' : 'light-link-color'">
                {{ $t('settingsNav.licenses') }}
              </v-list-item>
            </router-link>
            <router-link v-if="!limitedUser" :to="`/settings/history`">
              <v-list-item :class="$vuetify.theme.dark ? 'dark-link-color' : 'light-link-color'">
                {{ $t('settingsNav.orderhistory') }}
              </v-list-item>
            </router-link>
            <router-link v-if="!limitedUser" :to="`/settings/preferences`">
              <v-list-item :class="$vuetify.theme.dark ? 'dark-link-color' : 'light-link-color'">
                {{ $t('settingsNav.preferences') }}
              </v-list-item>
            </router-link>

            <v-divider></v-divider>

            <router-link :to="`/update/e6-connect`">
              <v-list-item :class="$vuetify.theme.dark ? 'dark-link-color' : 'light-link-color'">
                {{ $t('nav.downloads') }}
              </v-list-item>
            </router-link>

            <v-divider></v-divider>

            <a v-if="isDev()" href="#" @click.prevent="handleNewPortalNavigation">
              <v-list-item :class="$vuetify.theme.dark ? 'dark-link-color' : 'light-link-color'">
                <v-icon :color="$vuetify.theme.dark ? 'white' : 'success'" class="pr-1">
                  star
                </v-icon>
                New Portal
                <v-icon :color="$vuetify.theme.dark ? 'white' : 'success'" class="pl-1">
                  star
                </v-icon>
              </v-list-item>
            </a>

            <v-divider v-if="isDev()"></v-divider>

            <v-list-item data-cy="logoutLink" @click="logout()">{{ $t('nav.logout') }}</v-list-item>
          </v-list>
        </v-menu>
      </div>

      <div v-else class="toolbar-menu no-auth-toolbar">
        <img class="top-nav-icon no-auth" height="40" width="40" :src="E6Logo" alt="E6 Logo" />
        <v-tabs v-model="selected" dark class="tabs-bar">
          <v-tabs-slider class="slider" color="primary" secondary></v-tabs-slider>
          <v-tab
            v-for="(item, i) in noAuthMenu"
            :key="i"
            :class="['tab-item', `item-${i}`]"
            :to="item.to"
            ripple
          >
            <span>{{ item.title }}</span>
          </v-tab>
        </v-tabs>
        <v-btn v-if="!isAuthenticated" text class="hidden-logout no-auth-btn" @click="login">
          {{ $t('nav.login') }}
        </v-btn>
      </div>
    </v-toolbar>

    <!-- this is the clubhouse info toolbar -->
    <transition name="fadeDown" appear>
      <DetailedToolbar
        v-if="
          isAuthenticated &&
          ($route.meta.clubhouseToolbar || canViewToolbar) &&
          !$route.path.includes('admin')
        "
      ></DetailedToolbar>
    </transition>

    <!-- BACKGROUND IMAGE -->
    <transition name="fade" appear>
      <div
        v-if="
          !isAuthenticated ||
          userVerifyRoute ||
          userResetPassRoute ||
          clientLoginRoutes ||
          userQuestionsRoute
        "
        :class="{
          bg: !noAuthBgCheck,
          bg_ibm: isIBMPage,
        }"
      >
        <!-- gameClientLoginRoute || -->
        <!-- :class="noAuthBgCheck ? '' : 'bg'" -->
        <!-- :class="noAuthBgCheck ? '' : isDev() ? 'bg' : 'bg_v2'" -->
        <v-banner v-if="showAlert" class="alertMessage text-center" color="primary" dark>
          <h3>
            {{ $t('app.egolfWillBe') }}
          </h3>
        </v-banner>
        <!-- <div v-if="!isDev()" class="background-image-overlay"></div> -->
      </div>
    </transition>

    <main>
      <v-snackbar
        v-if="isAuthenticated && getMe && getMe.activated === false"
        v-model="snackbar"
        :timeout="-1"
        color="info"
        bottom
        center
        style="right: 100px"
      >
        {{ $t('app.checkYourEmail') }}
        <v-btn
          v-if="!sendingEmail && !emailSent"
          class="snackbar-action"
          text
          small
          dark
          @click="sendActivationEmail"
        >
          {{ $t('app.resendEmail') }}
        </v-btn>
        <v-progress-circular
          v-if="sendingEmail"
          class="snackbar-action"
          indeterminate
          :size="15"
        ></v-progress-circular>
        <span v-if="emailSent" class="snackbar-action">
          <v-icon>check_circle</v-icon> <b>Email sent</b>
        </span>
      </v-snackbar>

      <WelcomeDialog />

      <v-main id="app">
        <transition name="fade" mode="out-in">
          <router-view :is-developer="isDeveloper" @hasApex="hasApexCheck"></router-view>
        </transition>
        <LanguageSwitcher
          v-if="
            !$route.path.includes('/admin') &&
            $route &&
            $route.name !== 'Shotview' &&
            $route.name !== 'ShotviewData'
          "
        />
        <GhostUserAlert v-if="isAuthenticated" :authenticated="isAuthenticated" @logout="logout" />
      </v-main>
    </main>

    <v-tooltip v-if="(isAdmin || canViewAdmin) && !$route.meta.hideAdminButtons" top>
      <template #activator="{ on }">
        <v-btn
          v-if="isAdmin || canViewAdmin"
          small
          fab
          fixed
          left
          color="primary"
          :class="['admin-btn', routeCustomBtnPlacementCheck ? 'admin-btn_adj' : '']"
          v-on="on"
          @click.stop="changeAdmin"
        >
          <v-icon>lock</v-icon>
        </v-btn>
      </template>
      <span>Admin</span>
    </v-tooltip>

    <v-tooltip v-if="(isPartner || canViewPartnerAdmin) && !$route.meta.hideAdminButtons" top>
      <template #activator="{ on }">
        <v-btn
          v-if="isPartner || canViewPartnerAdmin"
          small
          fab
          fixed
          left
          color="primary"
          :class="[
            'partner-admin-btn',
            routeCustomBtnPlacementCheck ? 'partner-admin-btn_adj' : '',
          ]"
          v-on="on"
          @click.stop="changePartner"
        >
          <v-icon>handshake</v-icon>
        </v-btn>
      </template>
      <span>Partner</span>
    </v-tooltip>

    <v-tooltip v-if="isAPIPartner && !$route.meta.hideAdminButtons" top>
      <template #activator="{ on }">
        <v-btn
          v-if="isAPIPartner"
          small
          fab
          fixed
          left
          color="info"
          :class="['api-admin-btn', routeCustomBtnPlacementCheck ? 'api-admin-btn_adj' : '']"
          v-on="on"
          @click.stop="routeApiDashboard"
        >
          <v-icon>api</v-icon>
        </v-btn>
      </template>
      <span>API Dashboard</span>
    </v-tooltip>

    <!-- snackbar message -->
    <vtoast ref="vtoast" />
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';
import Router from 'vue-router';
import meMixin from '@/mixins/meMixin';
import utilityMixin from '@/mixins/utilityMixin';
import userClubPermissionMixin from '@/mixins/userClubPermissionMixin';
import vtoast from '@/components/shared/VToast';
import AppAdminNavDrawer from '@/components/shared/AppAdminNavDrawer';
import AppMobileNavDrawer from '@/components/shared/AppMobileNavDrawer';
import AppPartnerNavDrawer from '@/components/shared/AppPartnerNavDrawer';
import GhostUserAlert from '@/components/shared/GhostUserAlert';
import DetailedToolbar from '@/components/DetailedToolbar';
import WelcomeDialog from '@/components/WelcomeDialog';
import E6Logo from '@/assets/E6_Cube.png';
//* Alternate language switcher
// import LocaleSwitcher from '@/components/LocaleSwitcher';
import LanguageSwitcher from '@/components/LanguageSwitcher';
import { setDocumentDirectionPerLocale, setDocumentLang } from '@/utils/i18n/document';
import { isDev } from '@/utils/helpers';

const { isNavigationFailure, NavigationFailureType } = Router;

export default {
  components: {
    AppAdminNavDrawer,
    AppMobileNavDrawer,
    AppPartnerNavDrawer,
    DetailedToolbar,
    WelcomeDialog,
    LanguageSwitcher,
    vtoast,
    GhostUserAlert,
    //* Alternate language switcher
    // LocaleSwitcher,
  },
  mixins: [meMixin, utilityMixin, userClubPermissionMixin],

  metaInfo: {
    title: 'Portal',
    titleTemplate: '%s | E6 Golf',
    meta: [
      {
        vmid: 'description',
        name: 'description',
        content: 'E6 Golf user portal application for viewing user data.',
      },
      //* Facebook
      {
        vmid: 'og:site_name',
        name: 'og:site_name',
        content: 'E6 Golf Portal',
      },
      {
        vmid: 'og:title',
        name: 'og:title',
        content: 'E6 Golf Portal',
      },
      {
        vmid: 'og:description',
        name: 'og:description',
        content: 'E6 Golf user portal application',
      },
      //* Twitter
      {
        vmid: 'twitter:title',
        name: 'twitter:title',
        content: 'E6 Golf Portal',
      },
      {
        vmid: 'twitter:description',
        name: 'twitter:description',
        content: 'E6 Golf user portal application',
      },
      {
        vmid: 'twitter:card',
        name: 'twitter:card',
        content: 'summary',
      },
    ],
  },

  data() {
    return {
      adminDrawer: false,
      partnerDrawer: false,
      showAlert: false,

      // Drawer attribute values
      clipped: true,
      drawer: false,
      fixed: false,
      miniVariant: true,
      selected: 8,
      snackbar: true,
      badgeAnimated: false,
      localeDialog: false,
      mobileLocaleDialog: false,
      E6Logo,
      lazyProfileImage:
        'https://e6golf-qa-assets.imgix.net/shared/player-art/chipped.jpg?h=200&w=200&fit=crop',

      // tab items
      active: null,

      // Toolbar title
      title: 'E6Golf',
      isDev,
      hasApex: false,
    };
  },

  computed: {
    ...mapGetters('authentication', ['isAuthenticated', 'adminSite']),
    ...mapGetters({
      clubhouses: 'clubhouses/list',
      userInfo: 'users/getMe',
      userClubhouse: 'users/getClubhouse',
      // permitted: 'users/permitted',
      // permissionMessage: 'users/permissionMessage',
      isAdmin: 'users/isAdmin',
      isDeveloper: 'users/isDeveloper',
      canViewAdmin: 'users/canViewAdmin',
      isPartner: 'users/isPartner',
      canViewPartnerAdmin: 'users/canViewPartnerAdmin',
      currentPartnerID: 'users/currentPartnerID',
      hasReseller: 'users/hasReseller',
      limitedUser: 'users/limitedUser',
      itemTotal: 'shop/cartItemTotal',
      isLoadingUser: 'users/isLoadingUser',
      hasClubhouse: 'users/hasClubhouse',
      isAPIPartner: 'users/isAPIPartner',
    }),

    // ? Not sure if we need this styling computed prop anymore
    slider() {
      if (this.tabKeys.indexOf(this.$route?.name) > -1) {
        return 'display: inline';
        // return 'display: flex'
      }
      return 'display: none';
    },

    dark() {
      if (this.isDarkMode) {
        return true;
      }

      if (!this.getMe?.preferences) {
        const user = JSON.parse(localStorage.getItem('userPreferences'));
        if (user !== null || user !== undefined) {
          return user?.preferences?.darkMode;
        }

        return false;
      }
      return this.getMe?.preferences ? this.getMe?.preferences?.darkMode : false;
    },

    noAuthMenu() {
      return [{ title: `${this.$t('nav.shop')}`, to: '/shop' }];
    },

    topMenu() {
      let menu = [];
      const meID = this.getMe?.id ? this.getMe.id : undefined;

      // if (this.clubhouse === undefined) {
      //   menu = this.tabs
      // } else {
      //   menu = [
      //     { title: 'Home', to: `/dashboard`, },
      //     // { title: 'Dashboard', to: `/clubhouses/${this.clubhouse ? this.clubhouse.id : ''}/dashboard`, },
      //     { title: 'Dashboard', to: `/clubhouses/dashboard`, },
      //     { title: 'Events', to: '/events', },
      //     // { title: 'Clubhouses', to: '/clubhouses', },
      //     // { title: 'Courses', to: '/courses', },
      //   ]
      // }

      if (meID) {
        menu = [
          // { title: 'Dashboard', to: `/dashboard`, icon: 'dashboard' }, //* Old Dashboard page...phasing out
          { title: `${this.$t('nav.dashboard')}`, to: `/users/${meID}`, icon: 'dashboard' },
          // { title: 'My Clubhouse', to: `/clubhouse${this.dashboardLink}`, }, //* This route works to route appropriately
          this.clubhouse
            ? {
                title: `${this.$t('nav.myClubhouse')}`,
                to: {
                  path: `/clubhouse${this.dashboardLink}`,
                  props: true,
                  name: this.dashboardLink === 's' ? 'clubhouses' : 'clubhouseDashboard',
                  params: {
                    clubhouseID: this.dashboardLink,
                    clubhouse: this.clubhouse,
                  },
                },
              } //* This route works to route appropriately
            : { title: `${this.$t('nav.clubhouses')}`, to: '/clubhouses' },
          this.clubhouse ? { title: `${this.$t('nav.allClubhouses')}`, to: '/clubhouses' } : {},
          // { title: 'Events', to: '/events', },
          { title: `${this.$t('nav.events')}`, to: `/users/${meID}/events` },
          { title: `${this.$t('nav.seasons')}`, to: `/users/${meID}/seasons` }, //* User Seasons
          // this.hasApex
          //   ? { title: `${this.$t('nav.analytics')}`, to: `/users/${meID}/analytics` }
          //   : null, //* Shot analytics
          { title: `${this.$t('nav.analytics')}`, to: `/users/${meID}/analytics` }, //* Shot Analytics - Apex
          !this.limitedUser ? { title: `${this.$t('nav.shop')}`, to: '/shop' } : null,
        ];
      }

      return menu;
    },

    filteredTopMenu() {
      return this.topMenu.filter((item) => {
        return item !== null && item?.to !== undefined;
      });
    },

    dashboardLink() {
      //* Set the appropriate link depending on if clubhouse owner or not
      //* Will navigate to list of clubhouses if not a clubhouse owner allowing to browse clubhouse pages
      let link = '';
      const club = this.clubhouse;

      if (club) {
        // link = `/${club.id}/dashboard`
        link = `${club.id}`;
      } else {
        link = `s`;
      }

      return link;
    },

    clubhouse() {
      if ((!this.clubhouses || !this.clubhouses?.length) && this.isAuthenticated) {
        this.$store.dispatch('clubhouses/list');
      } else {
        const club = this.clubhouses?.filter((clubhouse) => {
          if (this.userInfo?.club === null || this.userInfo?.club === undefined) {
            return;
          }
          return clubhouse.uuid === this.userInfo?.club?.[0]?.uuid;
        });

        // TODO need to factor in multiple clubhouses
        return club ? club[0] : club;
      }
      return {};
    },

    profileImage() {
      return this.getMe?.profileImage ? this.getMe?.profileImage : '';
    },

    displayName() {
      return this.getMe?.displayName ? this.getMe?.displayName : '';
    },

    meID() {
      const meID = this.getMe?.id ? this.getMe.id : undefined;
      return meID;
    },

    routeAuthCheck() {
      const routeName = this.$route?.name;
      return (
        routeName !== 'login' &&
        routeName !== 'signup' &&
        routeName !== 'signUp' &&
        routeName !== 'phoneLogin' &&
        routeName !== 'tos' &&
        routeName !== 'resetPassword' &&
        routeName !== 'UserVerificationPasswordReset' &&
        !this.$route?.meta?.requiresAuth
      );
    },

    routeCustomBtnPlacementCheck() {
      const routeName = this.$route?.name;
      return (
        routeName === 'Analytics' ||
        routeName === 'Analytics2' ||
        routeName === 'userGolfBagManagement' ||
        routeName === 'apexEventDetails'
      );
    },

    // Check to hide the top toolbar based on route
    toolbarRouteCheck() {
      return (
        this.$route &&
        this.$route?.name !== 'SocialShare' &&
        this.$route?.name !== 'Shotview' &&
        this.$route?.name !== 'resetPassword' &&
        this.$route?.name !== 'ShotviewData' &&
        this.$route?.name !== 'GameClientLogin' &&
        this.$route?.name !== 'UserVerificationLogin' &&
        this.$route?.name !== 'JoinEventQueueLogin' &&
        this.$route?.name !== 'GuestAccountCreate' &&
        this.$route?.name !== 'UserQuestions' &&
        this.$route?.name !== 'UserVerificationQuestions' &&
        this.$route?.name !== 'UserQuestionQRView' &&
        this.$route?.name !== 'CustomTosView' &&
        this.$route?.name !== 'CustomPrivacyView'
      );
    },

    userVerifyRoute() {
      return this.$route?.name === 'UserVerificationLogin';
    },

    gameClientLoginRoute() {
      return this.$route?.name === 'GameClientLogin';
    },

    clientLoginRoutes() {
      return (
        this.$route?.name === 'GameClientLogin' ||
        this.$route?.name === 'JoinEventQueueLogin' ||
        this.$route?.name === 'GuestAccountCreate'
      );
    },

    userResetPassRoute() {
      return this.$route?.name === 'UserVerificationPasswordReset';
    },

    userQuestionsRoute() {
      return (
        this.$route?.name === 'UserQuestions' ||
        this.$route?.name === 'UserVerificationQuestions' ||
        this.$route?.name === 'UserQuestionQRView'
      );
    },

    noAuthBgCheck() {
      return (
        this.$route &&
        (this.$route.name === 'SocialShare' ||
          this.$route.name === 'Shotview' ||
          this.$route.name === 'ShotviewData' ||
          this.$route.name === 'notFound')
      );
    },

    isIBMPage() {
      return (
        this.$route &&
        (this.$route.name === 'UserQuestions' ||
          this.$route.name === 'UserQuestionQRView' ||
          this.$route.name === 'UserVerificationQuestions')
      );
    },

    itemTotalLength() {
      return this.itemTotal?.toString()?.length ?? 1;
    },
  },

  watch: {
    itemTotal() {
      this.badgeAnimated = true;
    },
  },

  mounted() {
    this.$root.vtoast = this.$refs.vtoast;
    this.$watch(
      '$i18n.locale',
      (newLocale, oldLocale) => {
        if (newLocale === oldLocale) {
          return;
        }
        setDocumentLang(newLocale);
        setDocumentDirectionPerLocale(newLocale);
      },
      { immediate: true }
    );
  },

  methods: {
    //* Logout calls the logout action from the authentication module within Vuex
    logout() {
      this.$store.dispatch('authentication/logout');
      this.$store.dispatch('users/resetState');
      this.$store.dispatch('licenses/resetLicenses');

      // remove users preferences from local storage
      localStorage.removeItem('userPreferences');

      this.$router.push('/login').catch((e) => {
        if (!isNavigationFailure(e, NavigationFailureType.redirected)) {
          Promise.reject(e);
        }
      });
    },

    login() {
      this.$router.push('/login').catch((e) => {
        if (!isNavigationFailure(e, NavigationFailureType.redirected)) {
          Promise.reject(e);
        }
      });
    },

    //* sendActivationEmail sends an activation email to the authenticated user
    sendActivationEmail() {
      this.$store.dispatch('users/sendActivationEmail');
    },

    //* routeTo the given endpoint
    routeTo(endpoint) {
      this.$router
        .push(endpoint)
        .then(() => {
          this.adminDrawer = false;
          this.partnerDrawer = false;
          this.drawer = false;
        })
        .catch((e) => {
          if (!isNavigationFailure(e, NavigationFailureType.redirected)) {
            Promise.reject(e);
          }
        });
    },

    changeAdmin() {
      this.adminDrawer = !this.adminDrawer;
      this.partnerDrawer = false;
      this.drawer = false;
    },

    changePartner() {
      this.partnerDrawer = !this.partnerDrawer;
      this.adminDrawer = false;
      this.drawer = false;
    },

    routeApiDashboard() {
      this.partnerDrawer = false;
      this.adminDrawer = false;
      this.drawer = false;
      this.$router
        .push({
          name: 'APIDashboard',
          props: true,
        })
        .catch((e) => {
          if (!isNavigationFailure(e, NavigationFailureType.redirected)) {
            Promise.reject(e);
          }
        });
    },

    closeMobileDrawer() {
      this.drawer = false;
    },

    setDrawerValue(data) {
      this.drawer = data;
    },

    goToCart() {
      if (this.$route?.name !== 'ShoppingCart') {
        this.$router
          .push({
            name: 'ShoppingCart',
            params: {
              title: 'cart',
            },
          })
          .catch((e) => {
            if (!isNavigationFailure(e, NavigationFailureType.redirected)) {
              Promise.reject(e);
            }
          });
      }
    },

    manageBilling(e) {
      e.preventDefault();
      this.$store.dispatch('shop/manageBilling').then((res) => {
        window.open(`${res.billing_portal_url}`, '_self');
      });
    },

    //* Capture emitted hasApex data check from UserInfoCard. Look into moving that check and passing down to card
    hasApexCheck(data) {
      this.hasApex = data;
    },

    handleNewPortalNavigation() {
      const token = localStorage.getItem('token');
      const user = JSON.parse(localStorage.getItem('e6User') || '{}');

      if (!token || !user?.me?.id || !user?.me?.email) {
        alert('Missing auth info — please log in again.');
        return;
      }

      const query = new URLSearchParams({
        token,
        id: user?.me?.id,
        email: user?.me?.email,
      });

      //* Temp with new portal stg app
      const url = `https://apex-web-stg-1086996803216.us-central1.run.app/auth/sync?${query.toString()}`;
      // const url = `http://localhost:7777/auth/sync?${query.toString()}`;

      // Redirect to new portal app
      window.open(url, '_blank');
    },
  },
};
</script>

<style lang="scss">
@import './assets/css/mainStyles.css';
@import '~vuetify/src/styles/styles.sass';

.container {
  /* padding: 24px 0 !important; */
  /* padding: 0 !important; */ /** This was originall added with container width */
  min-height: calc(100vh - 65px) !important;
}

.background-image-overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: rgba(255, 255, 255, 0.8);
}

.bg_v2 {
  position: fixed;
  background-image: url('./assets/landscape-vector-comp.png');
  /* background-image: url('./assets/E6_login.jpg'); */
  /* Full height */
  height: 100%;
  width: 100%;
  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  z-index: 1;
}

.bg {
  position: fixed;
  /* background-image: url('./assets/E6_login.jpg'); */
  background-image: url('./assets/E6-APEX_login_2024.png');
  height: 100%;
  width: 100%;
  aspect-ratio: 16 / 9;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  z-index: 1;
  top: 0;
}

.bg_ibm {
  position: fixed;
  background-image: url('./assets/E6_IBM-bg.jpg');
  height: 100%;
  width: 100%;
  aspect-ratio: 16 / 9;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  z-index: 1;
  top: 0;
}

main {
  z-index: 2;
}

.toolbar {
  display: flex !important;
  justify-content: center !important;
  box-shadow: none !important;
}

.toolbar-menu {
  display: flex;
  justify-content: space-between;
  width: 1280px !important;
}

.toolbar-icon {
  margin-right: 12px;
}

/* .active-user-container { */
/* padding: 5px 0; */
/* } */

.active-user-details > span {
  font-weight: 500;
  font-size: 1.375rem;
  font-weight: bold;
}

.dropdown-title {
  text-align: right;
  font-weight: 400;
  font-size: 13px;
}

.buttons-container {
  display: flex;
  justify-content: space-between;
}

.outer-nav-items {
  margin-top: 8px;
}

.top-nav-icon {
  margin-top: 7px;
  margin-right: 7px;
  cursor: pointer;
}

.v-tabs__container {
  height: 64px;
}

.toolbar .toolbar-menu .v-tabs-bar {
  background-color: transparent;
}

.tab-item > a {
  color: #ffffff;
  height: 100%;
  width: 100%;
  line-height: 63px;
  padding: 0 24px;
}

.tab-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
  transition: background-color 0.3s;
}

.buttons-container > .btn {
  margin-bottom: 0px;
}

/* Check These */
.cart-badge {
  top: 20px;
  right: 15px;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  -webkit-user-select: none; /* Chrome/Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+ */
}

.cart-badge .v-badge__badge {
  font-size: 12px;
  width: 20px;
  height: 20px;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  -webkit-user-select: none; /* Chrome/Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+ */
}

.cart-badge-lg > span.v-badge__wrapper > span > div > span {
  margin-left: -2px;
  font-size: 0.6rem;
}

.locale-badge {
  top: 15px;
  right: 25px;
}
/* Check These */

title {
  color: #ffffff;
}

a {
  text-decoration: none;
}

.container {
  /* width: 1280px !important; */ /** This was originall added with container width */
  /* max-width: 1280px; */ /** This was originall added with container width */
  position: relative;
}

.icon-color {
  color: #ba2127;
}

.avatar-tile {
  margin-top: 16px;
  margin-bottom: 16px;
}

/* .menu-item {} */

.subItem {
  margin-left: 10px;
}

.username {
  font-weight: 500;
  font-size: 16px;
}

.left-nav-divider {
  margin: 15px 0;
}

.links {
  margin-right: 24px;
}

.logo-container {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 25px 0;
}

.logo {
  width: 75px;
  height: 75px;
}

/* .toolbar {} */

.hamburger-menu {
  display: none;
}

/* .v-tabs-slider-wrapper {
  bottom: 2px;
} */

.detailed-toolbar .v-tabs-slider-wrapper {
  bottom: 0px;
}

.slider,
.v-tabs-slider-wrapper {
  height: 3px !important;
}

.hidden-logout {
  z-index: 9999;
}

.hidden-logout:hover {
  color: #ba2127;
}

.toolbar-title {
  font-size: 20px;
  margin-left: 24px;
  margin-top: 16px;
}

.snackbar-action {
  margin-left: 8px !important;
}

.nav-drawer {
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px rgba(0, 0, 0, 0.14),
    0 1px 10px rgba(0, 0, 0, 0.12);
  display: none;
}

.nav-menu-icon {
  display: none !important;
}

.edit-avatar:hover {
  background-color: rgba(0, 0, 0, 0.5);
}

.tabs-bar {
  margin-left: 24px;
}

.tabs-bar > div {
  height: 64px;
  background-color: transparent !important;
}

.admin-link {
  color: rgba(0, 0, 0, 0.87);
}

.admin-link > div:hover {
  background: rgba(0, 0, 0, 0.04);
}

/* .alertMessage { */
/* make sure it doesn't show up */
/* display: none;  */
/* } */

/* Check This */
.admin-btn {
  border-radius: 0 !important;
  left: 0 !important;
  top: 10vh;
  z-index: 6 !important;
}

.partner-admin-btn {
  border-radius: 0 !important;
  left: 0 !important;
  top: 15vh;
  z-index: 6 !important;
}

.api-admin-btn {
  border-radius: 0 !important;
  left: 0 !important;
  top: 20vh;
  z-index: 6 !important;
}

.admin-btn_adj {
  top: 85vh;
}

.partner-admin-btn_adj {
  top: 90vh;
}

.api-admin-btn_adj {
  top: 95vh;
}

.admin-drawer {
  z-index: 7 !important;
}

.top-nav-icon.no-auth {
  cursor: default;
}

.no-auth-btn {
  margin: 12px auto;
}

/* CSS to make image responsive */
.center-img {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}

@media (max-width: 1280px) {
  .toolbar-menu {
    width: 1000px !important;
  }

  /** This was originall added with container width */
  /* .container {
    width: 1000px !important;
  } */
}

@media (max-width: 1024px) {
  .cart-badge-container {
    position: absolute;
    /* position: fixed; */
    /* top: 0; */
    /* right: 0; */
    top: -5px;
    right: -10px;
  }

  .nav-drawer {
    display: inline !important;
  }

  .top-nav-icon {
    margin-top: 0;
  }

  .top-nav-icon.no-auth {
    margin-top: 10px;
    cursor: default;
  }

  .toolbar-menu.no-auth-toolbar {
    width: 600px;
  }
  /* Check This */

  .tablet {
    display: flex !important;
    justify-content: center !important;
  }

  .hidden-tablet {
    display: none !important;
  }

  .nav-menu-icon {
    display: block !important;
    position: absolute !important;
    /* position: fixed !important; */
    /* left: 0; */
    left: -10px;
    z-index: 999;
  }

  .toolbar-menu {
    width: 600px !important;
  }

  /* .container { */
  /* width: 720px; */
  /* width: 960px !important; */ /** This was originall added with container width */
  /* } */
}

@media screen and (max-width: 960px) {
  /** This was originall added with container width */
  /* .container {
    width: 720px !important;
    } */

  .v-tabs__container {
    height: 60px;
  }

  .toolbar-menu,
  .toolbar-menu.no-auth-toolbar {
    width: 720px;
    /* width: 500px; */
  }
}

@media (max-width: 1280px) {
  .hamburger-menu {
    display: block !important;
  }

  .tabs-bar {
    margin-left: 0px;
  }
}

@media screen and (max-width: 760px) {
  .toolbar-menu,
  .toolbar-menu.no-auth-toolbar {
    width: 480px !important;
  }
}

@media (max-width: 600px) {
  /* html,
  body {
    max-width: 100%;
    overflow-x: hidden;
  } */

  body {
    height: 100%;
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .e6-title {
    display: none;
  }

  .avatar-image {
    width: 30px;
    height: 30px;
  }

  .tabs-bar {
    margin-left: 0px;
  }

  /** This was originall added with container width */
  /* .container {
    width: 325px !important;
  } */

  .alertMessage h3 {
    font-size: 0.975rem;
    /* make sure it doesn't show up */
    /* display: none;  */
  }

  .toolbar-menu,
  .toolbar-menu.no-auth-toolbar {
    width: 325px !important;
  }

  .admin-btn_adj {
    top: 85vh;
    right: 0 !important;
    left: inherit !important;
  }

  .partner-admin-btn_adj {
    top: 90vh;
    right: 0 !important;
    left: inherit !important;
  }
}
</style>
